import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 防止重复点击时报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  // PC 首页
  {
    path: `/`,
    component: () => import('../views/pc/index/Index.vue'),
    children: [
      {
        path: `/`,
        component: () => import('../views/pc/index/Home.vue')
      },
      {
        path: 'area',
        component: () => import('../views/pc/index/Area.vue'),
        meta: {
          title: '业务领域-四川宏博腾科技有限公司'
        }
      },
      {
        path: 'about',
        component: () => import('../views/pc/index/About.vue'),
        meta: {
          title: '关于我们-四川宏博腾科技有限公司'
        }
      },
      {
        path: 'customer',
        component: () => import('../views/pc/index/Customer.vue'),
        meta: {
          title: '关于我们-四川宏博腾科技有限公司'
        }
      },
      {
        path: 'contact',
        component: () => import('../views/pc/index/Contact.vue'),
        meta: {
          title: '联系我们-四川宏博腾科技有限公司'
        }
      },
      {
        path: 'area/pro',
        component: () => import('../views/pc/index/Product.vue'),
        meta: {
          title: '工业产品-四川宏博腾科技有限公司'
        }
      },
      {
        path: 'area/dev',
        component: () => import('../views/pc/index/Development.vue'),
        meta: {
          title: '自控系统研发-四川宏博腾科技有限公司'
        }
      },
      {
        path: 'area/vis',
        component: () => import('../views/pc/index/Vision.vue'),
        meta: {
          title: '智能视觉-四川宏博腾科技有限公司'
        }
      },
      {
        path: 'area/edu',
        component: () => import('../views/pc/index/Education.vue'),
        meta: {
          title: '教育信息化-四川宏博腾科技有限公司'
        }
      }
    ]
  },

  // 手机端 首页
  {
    path: `/h5`,
    component: () => import('../views/mobile/index/Index.vue'),
    children:[{
      path: '/h5',
      component: () => import('../views/mobile/index/Home.vue')
    },{
      path: '/h5/area',
      component: () => import('../views/mobile/index/Area.vue'),
      meta: {
        title: '业务领域-四川宏博腾科技有限公司'
      }
    },
    {
      path: '/h5/about',
      component: () => import('../views/mobile/index/About.vue'),
      meta: {
        title: '关于我们-四川宏博腾科技有限公司'
      }
    },
    {
      path: '/h5/customer',
      component: () => import('../views/mobile/index/Customer.vue'),
      meta: {
        title: '关于我们-四川宏博腾科技有限公司'
      }
    },
    {
      path: '/h5/contact',
      component: () => import('../views/mobile/index/Contact.vue'),
      meta: {
        title: '联系我们-四川宏博腾科技有限公司'
      }
    },
    {
      path: '/h5/area/pro',
      component: () => import('../views/mobile/index/Product.vue'),
      meta: {
        title: '工业产品-四川宏博腾科技有限公司'
      }
    },
    {
      path: '/h5/area/dev',
      component: () => import('../views/mobile/index/Development.vue'),
      meta: {
        title: '自控系统研发-四川宏博腾科技有限公司'
      }
    },
    {
      path: '/h5/area/vis',
      component: () => import('../views/mobile/index/Vision.vue'),
      meta: {
        title: '智能视觉-四川宏博腾科技有限公司'
      }
    },
    {
      path: '/h5/area/edu',
      component: () => import('../views/mobile/index/Education.vue'),
      meta: {
        title: '教育信息化-四川宏博腾科技有限公司'
      }
    }]
  },

  // 404
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: '未找到页面'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
  // scrollBehavior(to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 }
  //   }
  // }
})

router.beforeEach((to, from, next) => {
  // console.log("to", to);
  // console.log( 'from', from);
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '四川宏博腾科技有限公司'
  }
  window.scrollTo(0, 0)
  next()
})

export default router
